<template>
	<div class="admin-container">
		<div class="main-layout">
			<div class="left-menu">
				<el-menu default-active="" class="menu-container" @select="handleMenuSelect">
					<el-menu-item index="user">
						<i class="el-icon-user"></i>
						<span slot="title">用户管理</span>
					</el-menu-item>
					<el-menu-item index="model">
						<i class="el-icon-cpu"></i>
						<span slot="title">模型管理</span>
					</el-menu-item>
					<el-menu-item index="course">
						<i class="el-icon-menu"></i>
						<span slot="title">课程管理</span>
					</el-menu-item>
					<el-menu-item index="class">
						<i class="el-icon-s-data"></i>
						<span slot="title">班级管理</span>
					</el-menu-item>
					<el-menu-item index="organization">
						<i class="el-icon-school"></i>
						<span slot="title">机构管理</span>
					</el-menu-item>
					<el-menu-item index="memuRole">
						<i class="el-icon-connection"></i>
						<span slot="title">菜单角色</span>
					</el-menu-item>
					<el-menu-item index="basicSettings">
						<i class="el-icon-setting"></i>
						<span slot="title">基础设置</span>
					</el-menu-item>
					<el-menu-item index="logManagement">
					  <i class="el-icon-s-order"></i>
					  <span slot="title">日志管理</span>
					</el-menu-item>
				</el-menu>
			</div>

			<!-- 右侧内容区域 -->
			<div class="right-content">
				<!-- 默认欢迎页 -->
				<div v-if="activeMenu === ''" class="welcome-page">
					<div class="welcome-card">
						<h2>🎉 欢迎 {{ loginUser }} 登录管理中台</h2>
						<p>请从左侧菜单选择需要操作的功能模块</p>
					</div>
				</div>
				<!-- 子组件区域（根据菜单切换） -->
				<component :is="activeComponent" v-else></component>

			</div>
		</div>
		
	</div>
</template>

<script>
	// 引入子组件（也可改用懒加载）
	import UserManage from './manage/UserManage'
	import CourseManage from './manage/CourseManage/StandardCourseManagement.vue'
	import ClassManage from './manage/ClassManage'
	import OrganizationManage from './manage/OrganizationManage'
	import BasicSettings from './manage/BasicSettings'
	import ModelManage from './manage/ModelManage'
	import Menu from './manage/Menu'
	import LogManagement from './manage/LogManagement'
	import {
		logOutType
	} from '../login.js'
	export default {
		components: {
			UserManage,
			CourseManage,
			ClassManage,
			OrganizationManage,
			BasicSettings,
			ModelManage,
			Menu,
			LogManagement,
		},
		data() {
			return {
				// 登录账号（可从localStorage读取）
				loginUser: localStorage.getItem('nickName'),
				userId: localStorage.getItem('userId'),
				userType: localStorage.getItem('userType'),
				// 激活的菜单（默认空）
				activeMenu: '',
				// 激活的组件
				activeComponent: '',
				showPassword: false,
				showChangeText: false,
				menu:false,
			}
		},
		created() {
			if(localStorage.getItem("AdminMenu")){
				this.handleMenuSelect(localStorage.getItem("AdminMenu"))
			}
		},
		methods: {
			handleDropdown(command) {
				if (command === 'changePwd') {
					this.showPassword = true
				} else if (command === 'changeText') {
					this.showChangeText = true
				}
			},
			handleChangePwd(val) {
				console.log('val', val)
			},
			// 菜单选择事件
			handleMenuSelect(index) {
				
				this.activeMenu = index
				// 菜单和组件映射
				const menuMap = {
					user: 'UserManage',
					course: 'CourseManage',
					class: 'ClassManage',
					organization:"OrganizationManage",
					basicSettings:"BasicSettings",
					model:'ModelManage',
					memuRole:"Menu",
					logManagement:"LogManagement",
				}
				localStorage.setItem("AdminMenu",index)
				this.activeComponent = menuMap[index]
			},
			
		}
	}
</script>

<style scoped>
	/* 全局容器 */
	.admin-container {
		width: 100vw;
		height: 100vh;
		display: flex;
		flex-direction: column;
		background: #f5f7fa;
		box-sizing: border-box;
	}

	/* 顶部导航栏 */
	.top-nav {
		height: 60px;
		line-height: 60px;
		background: #1e88e5;
		color: #fff;
		padding: 0 20px;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.logo {
		font-size: 18px;
		font-weight: bold;
	}

	.user-info {
		display: flex;
		align-items: center;
		gap: 20px;
	}

	.logout-btn {
		color: #fff;
	}

	/* 核心布局 */
	.main-layout {
		flex: 1;
		display: flex;
		overflow: hidden;
	}

	/* 左侧菜单 */
	.left-menu {
		width: 200px;
		background: #fff;
		border-right: 1px solid #e6e6e6;
	}

	.menu-container {
		height: 100%;
		border-right: none;
	}

	/* 右侧内容区域 */
	.right-content {
		flex: 1;
		padding: 20px;
		overflow-y: auto;
	}

	/* 默认欢迎页 */
	.welcome-page {
		width: 100%;
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.welcome-card {
		width: 60%;
		background: #fff;
		padding: 40px;
		border-radius: 12px;
		text-align: center;
		box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
	}

	.welcome-card h2 {
		color: #1e88e5;
		margin-bottom: 20px;
	}

	.welcome-card p {
		color: #666;
		font-size: 16px;
	}

	/* 平板适配 */
	@media (max-width: 768px) {
		.main-layout {
			flex-direction: column;
		}

		.left-menu {
			width: 100%;
			height: auto;
			border-right: none;
			border-bottom: 1px solid #e6e6e6;
		}

		.welcome-card {
			width: 90%;
			padding: 20px;
		}
	}
</style>